import React from 'react';
import './NoData.scss';

interface NoDataProps {
  message?: string;
}

export const NoData: React.FC<NoDataProps> = ({ message = 'No data available' }) => {
  return <div className="noData">{message}</div>;
};
